import { maybe, Maybe, rd, RemoteData } from '@passionware/monads';
import {
  withWorkspaceScoping,
  WithWorkspaceScoping
} from 'v5/api/_common/query/workspace-scoping';
import { ResolvedAppScope } from '../appScope.types';
import { workspaceScopingFromResolvedScope } from './workspaceScopingFromResolvedScope';

/**
 * Applies list query workspace filters from resolved app scope (URL-derived), not the enterprise
 * feature flag. Legacy org URLs → global list; `/w/{ws}/...` → workspace-filtered list.
 */
export function useWithWorkspaceScoping<T>(
  scopeRd: RemoteData<ResolvedAppScope>,
  searchQuery: T
): Maybe<WithWorkspaceScoping<T>> {
  return rd.tryMap(scopeRd, scope =>
    withWorkspaceScoping(searchQuery, workspaceScopingFromResolvedScope(scope))
  );
}
